import React, { FC, useEffect, useState } from 'react';
import { StyledWrapper } from './style';
import Container from '@/Components/atoms/Container';
import { useGetProductDetail } from '@/Page/ProductDetail/Hooks/useGetProductDetail';
import CommonSvg, { svgNames } from '@/Components/atoms/CommonSvg';
import { IconButton, Stack } from '@mui/material';
import { useRouter } from 'next/router';
import { FiShare } from 'react-icons/fi';
import { useIsAuth } from '@/Hooks/useIsAuth';
import FavoriteApi from '@/Services/Axios/Controllers/FavoriteApi';
import { WEBSITE_URL } from '@/Data/Constants';
import FlagSvg from '@/Components/atoms/CommonSvg/flagSvg';
import ShareBtn from '@/Components/atoms/ShareBtn';

type Props = {
  openComplainModal: () => void;
}

const ProductDetailHeader: FC<Props> = ({ openComplainModal }) => {
  const router = useRouter();
  const isAuth = useIsAuth();
  const [productId, product] = useGetProductDetail();
  const [bg, setBg] = useState('rgba(255, 255, 255, 0.05)');
  const [shadow, setShadow] = useState(false);
  const [isFavorite, setIsFavorite] = React.useState(!!product.favorite);
  const [isFavoriteServer, setIsFavoriteServer] = React.useState(!!product.favorite);




  const go_back = () => {
    router.back();
  }

  const toggleFavorite = () => {
    if (!isAuth) {
      router.push(`/auth?from=/item/${productId}`);
      return;
    }
    setIsFavorite(p => !p);
  };

  const shareData = {
    url: `${WEBSITE_URL}/item/${product.id}`,
  };

  const shareUrl = () => {
    const shareData = {
      url: `${WEBSITE_URL}/item/${productId}`
    };

    if (navigator?.share && navigator?.canShare(shareData)) {
      navigator?.share(shareData)
    } else {
      // Do something else like copying the data to the clipboard
    }
  }

  useEffect(() => {
    const handler = () => {
      const height = window.innerHeight / 2;
      const moved = window.scrollY;
      const rate = moved / height;
      setShadow(rate > 0.75);
      setBg(`rgba(255, 255, 255, ${rate})`);
    }
    handler();
    window.addEventListener('scroll', handler)
    return () => window.removeEventListener('scroll', handler);
  }, []);

  useEffect(() => {
    const idTimeout = setTimeout(() => {
      // NOTE: agar boshlang'ich holat bilan keyingi holat teng bo'lmasa request ketadi
      if(isFavorite !== isFavoriteServer) {
        FavoriteApi.toggleFavorite(product.id)
          .then((res) => {
            if ((res.data.message as string).includes("Remove")) {
              setIsFavorite(false);
              setIsFavoriteServer(false);
              product.favorite = false;
            } else {
              setIsFavorite(true);
              setIsFavoriteServer(true);
              product.favorite = true;
            }
          });
      }
    }, 500);

    return () => {
      clearTimeout(idTimeout)
    };
  }, [isFavorite]);

  return (
    <StyledWrapper className='ProductDetailHeader' style={{ boxShadow: shadow ? '0 5px 5px -5px rgba(0, 0, 0, 0.1)' : '' }}>
      <Container className='ProductDetailHeader__container' style={{ backgroundColor: bg }}>
        <Stack direction={'row'} justifyContent={'space-between'}>
          <IconButton className='ProductDetailHeader__icon-btn' disableRipple onClick={go_back}>
            <CommonSvg name={svgNames.ArrowLeft} />
          </IconButton>

          <Stack spacing={2} direction={'row'} className='icons-stack'>
          <IconButton className='ProductDetailHeader__icon-btn'>
            <ShareBtn shareUrl={shareUrl} shareData={shareData} />
          </IconButton>
            {/* <ShareBtn shareUrl={shareUrl} shareData={{ url: `${WEBSITE_URL}/item/${productId}` }} /> */}
            <IconButton className='ProductDetailHeader__icon-btn' disableRipple onClick={openComplainModal}>
              <FlagSvg />
            </IconButton>
            <IconButton className='ProductDetailHeader__icon-btn' disableRipple onClick={toggleFavorite}>
              <CommonSvg name={svgNames.Heart} style={{ color: isFavorite ? 'red' : '#fff' }} />
            </IconButton>
          </Stack>
        </Stack>
      </Container>
    </StyledWrapper>
  )
}

export default ProductDetailHeader;
